import styled from "@emotion/styled";
import { TwitterIcon } from "components/Icons";
import { Spacer } from "components/general/Spacer/Spacer";
import { Text } from "components/general/Text";
import { useMemo } from "react";
import { Token } from "store/global/TokenEnum";
import { getShareTweetLink } from "utils/shareTradeUtils";

interface ShareTradeBtnProps {
  sellTokenSymbols: Array<Token>;
  buyTokenSymbols: Array<Token>;
}

export const ShareTradeBtn = ({ sellTokenSymbols, buyTokenSymbols }: ShareTradeBtnProps) => {
  const shareTweetLink = useMemo(
    () => getShareTweetLink(sellTokenSymbols, buyTokenSymbols),
    [buyTokenSymbols, sellTokenSymbols]
  );

  return (
    <Button onClick={() => window.open(shareTweetLink, "_blank", "noreferrer")}>
      <TwitterIcon width={20} height={20} />
      <Spacer width="6px" />
      <Text textStyle="Button" size="Medium">
        Share Trade
      </Text>
    </Button>
  );
};

// Sub-components

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 14px;
  padding: 13px 16px 13px 10px;
  color: ${props => props.theme.button.tertiary.text.default};
  background-color: ${props => props.theme.button.tertiary.surface.default};
  transition: background-color 150ms linear;

  &:hover {
    background-color: ${props => props.theme.button.tertiary.surface.hover};
    color: ${props => props.theme.button.tertiary.text.hover};
  }
`;
